import Dictionary from "@/types/Dictionary";
import WorkState from "./WorkState";

/** Contexte d'une machine à état d'un composant Work */
export default class WorkContext {
	/** Instance d'état du work */
	private state: WorkState;
	/** Résults du work */
	private results: any;
	/** Ajouter ici les propriétés spécifiques au contexte du Grid */
	private configs!: Dictionary<any>;
	/** Indique s'il est possible de créer un widget à partir du Work */
	private showConfigButtons: boolean;
	/** Variant utilisé */
	private variant: string;

	/** 
	 * Initialisation d'un Context de Work
	 * @param state 					Etat de départ
	 * @param results 					Référence vers results qui a va être mis à jour selon les états
	 * @param showConfigButtons			Indique s'il est possible de créer un widget à partir du Work
	 */
	public constructor(state: WorkState, results: any, configs: Dictionary<any>, variant: string, showConfigButtons: boolean = false) {
		this.results = results;
		this.configs = configs;
		this.showConfigButtons = showConfigButtons;
		this.variant = variant;
		
		/** Passage à l'état passé en paramètre */
		this.TransitionTo(state);

		/** Passage en mode Standard par défaut forcé
		 * @description le GoStandard est également fait ici car il ne s'applique pas à la première instanciation
		 * @todo A corriger !
		 */
		this.GoStandard();
	}

	//#region Results
	/** Renvoi le Results du Work */
	public get Results(): any {
		return this.results;
	}

	/** Affectation d'un results */
	public set Results(value: any) {
		this.results = value;
	}
	//#endregion Results
	//#region Configs
	/** Renvoi la configuration du Work */
	public get Configs(): any {
		return this.configs;
	}

	/** Affecte la configuration du Work */
	public set Configs(value: any) {
		this.configs = value;
	}
	//#endregion Configs
	//#region ShowConfigButtons
	/** Indique si les boutons de configuration sont affichés ou non */
	public get ShowConfigButtons(): boolean {
		return this.showConfigButtons;
	}
	
	/** Indique si les boutons de configuration sont affichés ou non */
	public set ShowConfigButtons(value: boolean) {
		this.showConfigButtons = value;
	}
	//#endregion ShowConfigButtons
	//#region Variant
	/** Renvoi le variant du Work */
	public get Variant(): any {
		return this.variant;
	}

	/** Affecte le variant du Work */
	public set Variant(value: any) {
		this.variant = value;
	}
	//#endregion Variant

	/** Changement de contexte */
	public TransitionTo(state: WorkState): void {
		console.debug(`Context: Transition to ${(<any>state).constructor.name}.`);

		this.state = state;
		this.state.SetContext(this);
		/** Passage en mode Standard par défaut */
		this.state.EnterStandard();
	}

	/** Affichage du Work en mode plein écran */
	public GoFullscreen(): void {
        this.state.EnterFullscreen();
    }

	/** Affichage du Work en mode Standard */
    public GoStandard(): void {
        this.state.EnterStandard();
    }
}